import gql from "graphql-tag";

const commonQuery = `
id
name
mainShiftId
mainShift {
  id
  title
  code
}
updatedAt
createdAt
`;

const queryCreate = gql`
  mutation($name: String! $mainShiftId: ID!) {
    createBranchLocation(data: { name: $name mainShiftId:$mainShiftId }) {
      ${commonQuery}
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!, $name: String $mainShiftId: ID) {
    updateBranchLocation(id: $id, data: { name: $name mainShiftId:$mainShiftId}) {
      ${commonQuery}
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deleteBranchLocation(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query($query: String, $limit: Int, $page: Int) {
    getAllBranchLocation(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      ${commonQuery}
     
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getBranchLocation(id: $id) {
      ${commonQuery}
      author {
        id
        fullname
      }
    }
  }
`;

export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
};
